module.exports = __webpack_public_path__ + "static/img/bailichengLogo.1b3deeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bailichengLogo.jpg
// module id = OVRc
// module chunks = 63